<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Ladesessioner</h1>
    <div class="comp-header__actions">
      <adm-payment-terminal-actions />
    </div>
  </div>
</div>
<div class="comp-header__queries" [formGroup]="state.form">
  <adm-text-search placeholder="Søg" (search$)="querySearchInput($event)" [searchText]="state.form.value.query ?? ''" />

  <mat-form-field>
    <mat-label>Periode</mat-label>
    <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
      <input formControlName="startDate" class="pointer" readonly matStartDate placeholder="Start dato" #dateRangeStart />
      <input formControlName="endDate" class="pointer" readonly matEndDate placeholder="Slut dato" #dateRangeEnd />
    </mat-date-range-input>
    <button type="button" matIconSuffix mat-icon-button aria-label="Åbn periodevælger" (click)="picker.open()">
      <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#calendar-s"></use></svg>
    </button>
    @if (state.form.controls.startDate.value || state.form.controls.endDate.value) {
      <mat-icon matSuffix class="clear-input-field-button" (click)="resetDates()"> close </mat-icon>
    }
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <adm-admin-payter-locations-type-ahead
    [initialId]="undefined"
    [filterByProp]="'formattedAddress'"
    (itemSelected)="locationSelected($event)"
    [resetTrigger]="state.resetTerminalsTrigger()" />
</div>
<div class="comp-main terminal-sessions">
  @if ((appState.isInErrorState$ | async) === false) {
    <ok-card [loading]="state.loading()">
      <ok-expand-list
        [trackBy]="'id'"
        [sort]="currentSort()"
        [data]="state.sessions().items"
        [itemTemplate]="sessionDetailTemplate"
        [configuration]="config()"
        (sortChange)="onSortChange($event)">
      </ok-expand-list>
      <mat-paginator
        #paginator
        class="paginator"
        [pageIndex]="state.viewState().page.pageIndex"
        [pageSize]="state.viewState().page.pageSize"
        [length]="state.sessions().totalCount || 0"
        [pageSizeOptions]="state.pagingOptions()"
        (page)="pageSwitch($event)"
        color="accent"
        [disabled]="state.loading()" />
    </ok-card>

    @if (state.sessions().items.length === 0 && !state.loading()) {
      <div class="no-results align-center">
        <p>Der blev ikke fundet nogen ladesessioner</p>
      </div>
    }
  }
</div>

<ng-template #updatedColumnTemplate let-terminalSession>
  <div class="updated">
    {{ terminalSession.updated | date: 'medium' }}
    @if (terminalSession.lastActivity) {
      <div class="minutesSinceActivity">
        {{ moment(terminalSession.lastActivity).fromNow() }}
      </div>
    }
  </div>
</ng-template>

<ng-template #chargingTokenColumnTemplate let-terminalSession>
  <div>
    {{ terminalSession.chargingToken !== null ? terminalSession.chargingToken : '-' }}
    @if (terminalSession.chargingToken !== null) {
      <button
        type="button"
        class="copy-icon-button"
        aria-label="Kopiér chargingToken"
        (click)="$event.stopPropagation(); clipboardUtility.copy(terminalSession.chargingToken)">
        <mat-icon [matTooltip]="'Kopiér chargingToken'" svgIcon="content_copy"></mat-icon>
      </button>
    }
  </div>
  <div>
    {{ terminalSession.payterSessionId !== null ? terminalSession.payterSessionId : '-' }}
    @if (terminalSession.payterSessionId !== null) {
      <button
        type="button"
        class="copy-icon-button"
        aria-label="Kopiér payterSessionId"
        (click)="$event.stopPropagation(); clipboardUtility.copy(terminalSession.payterSessionId)">
        <mat-icon [matTooltip]="'Kopiér payterSessionId'" svgIcon="content_copy"></mat-icon>
      </button>
    }
  </div>
</ng-template>

<ng-template #serialNumberColumnTemplate let-terminalSession>
  <div class="serial-number">
    <a (click)="terminalEmulator(terminalSession)" class="blue pointer" title="{{ terminalSession.serialNumber }}">
      {{ terminalSession.serialNumber !== null ? terminalSession.serialNumber : '-' }}
    </a>

    @if (terminalSession.chargingStationLocationNames.length > 0 || terminalSession.stationNumbers.length > 0) {
      @for (chargingStationLocationName of terminalSession.chargingStationLocationNames; track $index) {
        <span> <mat-icon>travel_explore</mat-icon> {{ chargingStationLocationName }}</span>
      }

      @for (stationNumber of terminalSession.stationNumbers; track $index) {
        <span><mat-icon svgIcon="charger_outlined"></mat-icon> {{ stationNumber }}</span>
      }
    }
  </div>
</ng-template>

<ng-template #statusColumnTemplate let-terminalSession>
  <strong>Payter:</strong> {{ terminalSession.status }}<br />
  @if (terminalSession.firestoreRemoteTransaction?.status) {
    <span>
      <strong>Firestore:</strong>
      {{ terminalSession.firestoreRemoteTransaction.status }}
      <br />
      @if (terminalSession.firestoreRemoteTransaction.status === 'Charging') {
        <svg [matTooltip]="'Oplader...'" class="icon-20"><use href="assets/images/ok-icons-sprite.svg#state-charging"></use></svg>
      }
      @if (terminalSession.firestoreRemoteTransaction.chargeInWh) {
        {{ terminalSession.firestoreRemoteTransaction.chargeInWh | number: '1.0-4' }} Wh
      } @else if (
        terminalSession.firestoreRemoteTransaction.status === 'Finished' && terminalSession.firestoreRemoteTransaction.totalConsumptionInWh
      ) {
        {{ terminalSession.firestoreRemoteTransaction.totalConsumptionInWh / 1000 | number: '1.0-4' }} kWh
      }
    </span>
  }
</ng-template>

<ng-template #reservedAmountColumnTemplate let-terminalSession>
  <div class="reserved-amount">{{ (terminalSession.reservedAmountInOere ?? 0) / 100 | dkCurrency }}</div>
</ng-template>

<ng-template #commitAmountColumnTemplate let-terminalSession>
  <div class="committed-amount">{{ (terminalSession.commitAmountInOere ?? 0) / 100 | dkCurrency }}</div>
</ng-template>

<ng-template #sessionDetailTemplate let-terminalSession>
  <ok-card>
    <h5>Session for {{ terminalSession.chargingToken }}</h5>
    <div class="json">
      <pre>{{ sessionDetails(terminalSession) | json }}</pre>
    </div>
  </ok-card>
</ng-template>
